import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { formatDate } from 'lib/formatters';
import Avatar from 'components/Avatar';

const Message = ({ username, className, date, avatar, children, title, isMod, isVIP }) => (
  <aside className={className}>
    <div>
      <Avatar image={avatar} title={title || `${username}'s avatar`} alt="Avatar" />
      <p title={formatDate(date || Date.now(), "do MMM yyyy 'at' HH:mm")}>
        <span className="chat__message__username">
          {/* \u00a0 is non breaking space &nbsp; */}
          {isVIP ? '👑\u00a0' : ''}
          {username}:
        </span>
        {isMod ? (
          // eslint-disable-next-line react/no-danger -- Message from channel moderator
          <span className="chat__modMessage" dangerouslySetInnerHTML={{ __html: children }} />
        ) : (
          children
        )}
      </p>
    </div>
  </aside>
);

Message.propTypes = {
  children: PropTypes.string.isRequired,
  isMod: PropTypes.bool,
  isVIP: PropTypes.bool,
  avatar: PropTypes.string,
  username: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Message.defaultProps = {
  isMod: false,
  isVIP: false,
  avatar: '',
  username: '',
  className: '',
  title: null,
  date: 0
};

export default memo(Message, () => true);
